// extracted by mini-css-extract-plugin
export default {"provider-results-list":"EgbPBN","provider-results-list__wrapper":"TroUJ_","provider-results-list__overlay":"E57s3c","provider-results-list__load-more":"q0mFRb"};